module.exports = __webpack_public_path__ + "layout_com3.jpg?5fff891a7ac20cc41ac4b96dcf086422";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layouts/layout_com3.jpg
// module id = 84
// module chunks = 0